module.exports = __webpack_public_path__ + "static/media/s_v10_27.654b2894.mp3";